import { noWrapCss } from '--components/typography';
import { ColorName, getColor } from '--components/theme';
import * as React from 'react';
import styled from "styled-components";


type ListEntryTextProps = {
    primary: React.ReactNode;
    secondary?: React.ReactNode;
    tertiary?: React.ReactNode;
    dense?: boolean;
    emphasis?: boolean;
    noWrap?: boolean;
    color?: ColorName;
    secondaryColor?: ColorName;
    className?: string;
}

type TextProps = {
    emphasis?: boolean;
    dense?: boolean;
    noWrap?: boolean
    color?: ColorName
    secondaryColor?: ColorName;
}


const StyledListEntryText = styled.div<TextProps>`
    display: flex;
    flex-direction: ${props => props.dense ? "row" : "column"};
    flex: 0 1 100%;
    overflow: hidden;

    >div {
        flex: 0 1 auto;
        ${props => props.noWrap && noWrapCss}
    }
    >div:nth-child(1) {
        ${props => props.theme.typography.body1};
        font-weight: ${props => props.emphasis ? props.theme.typography.bold : "initial"};
        color: ${props => props.color ? getColor(props.color, props.theme) : props.emphasis ? props.theme.palette.text.primary : props.theme.palette.text.secondary};
        line-height: 1.2em;
        margin: 0;
    }
    >div:nth-child(2) {
        ${props => props.dense ? props.theme.typography.body1 : props.theme.typography.body2};
        color: ${props => props.secondaryColor ? getColor(props.secondaryColor, props.theme) : props.emphasis ? props.theme.palette.text.secondary : props.theme.palette.text.disabled};
        line-height: 1.2em;
        margin: ${props => props.dense ? props.theme.spacing(0, 0, 0, 1) : 0};
    }
    >div:nth-child(3) {
        ${props => props.dense ? props.theme.typography.body1 : props.theme.typography.body2};
        color: ${props => props.emphasis ? props.theme.palette.text.secondary : props.theme.palette.text.disabled};
        line-height: 1.2em;
        margin: ${props => props.dense ? props.theme.spacing(0, 0, 0, 1) : 0};
    }
`;

const ListEntryText: React.FC<ListEntryTextProps> = (props) => {
    const { primary, secondary, tertiary, dense, emphasis, noWrap, color, secondaryColor } = props;

    return <StyledListEntryText className={props.className} emphasis={emphasis} dense={dense} noWrap={noWrap} color={color} secondaryColor={secondaryColor}>
        <div>{primary}</div>
        {secondary && <div>{secondary}</div>}
        {tertiary && <div>{tertiary}</div>}
    </StyledListEntryText>
}

export default ListEntryText;
export { ListEntryText, ListEntryTextProps };